import { useMutation } from "react-query";
import { emailHubSubscriptionApi } from "@/react/emailHubSubscriptionApi";

export const useEmailHubSubscriptionApi = (
  onSuccess?: () => void,
  onError?: () => void,
) => {
  const {
    mutate: cancelEmailHubSubscription,
    isLoading: isCancellingEmailHubSubscription,
  } = useMutation(
    ({
      reason,
      reasonDescription,
    }: {
      reason: string;
      reasonDescription: string;
    }) => emailHubSubscriptionApi.cancel(reason, reasonDescription),
    {
      onSuccess: () => {
        onSuccess?.();
      },
      onError: () => {
        onError?.();
      },
    },
  );

  return {
    cancelEmailHubSubscription,
    isCancellingEmailHubSubscription,
  };
};
